import $ from 'jquery'
import 'slick-carousel'

export const renderSliderAllHotels = (slider) => {
  const hideDots = function ($slides, $dots) {
    const length = window.innerWidth <= 1024 ? 1 : 4
    if ($slides.length <= length) {
      $dots.hide()
    }
  }

  /*
  * Slick Slider Limit dots start
  */
  function setBoundries(slick, state) {
    if (state === 'default') {
      dotsContainer.find('ul.slick-dots li').eq(4).addClass('n-small');
    }
  }

  // Slick Selector.
  const slickSlider = $('.slider-all-hotels-container', slider)
  const maxDots = 5
  const transformXIntervalNext = -43
  const transformXIntervalPrev = 43
  const dotsContainer = slickSlider.next('.slick-dots-container')

  slickSlider.on('init breakpoint', function (event, slick) {
    const totalCount = dotsContainer.find('.slick-dots li').length
    if (totalCount < maxDots) {
      dotsContainer.addClass('uptomax')
    } else {
      dotsContainer.removeClass('uptomax')
    }
    dotsContainer.find('ul.slick-dots li').each(function (index) {
      $(this).addClass('dot-index-' + index)
    })
    setBoundries($(this),'default')
  })

  $(window).on('resize', function() {
    if($(window).width() < 1025) {
      slickSlider.slick('slickGoTo', 0, false);
      transformCount = 0;
      dotsContainer.find('ul.slick-dots').css('transform', 'translateX(0)')
    }
  })

  let transformCount = 0
  slickSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    const slidesToScroll = event.currentTarget.slick.options.slidesToScroll
    const totalCount = dotsContainer.find('.slick-dots li').length
    const nextSlideAccurated = Math.ceil((nextSlide / slidesToScroll) )
    const currentSlideAccurated = Math.ceil((currentSlide / slidesToScroll) )

    console.log(nextSlideAccurated, currentSlideAccurated)

    if (totalCount > maxDots) {
      if (nextSlideAccurated > currentSlideAccurated) {
        if (dotsContainer.find('ul.slick-dots li.dot-index-' + nextSlideAccurated).hasClass('n-small')) {
          console.log(nextSlideAccurated, 'plus')
          if (!dotsContainer.find('ul.slick-dots li:last-child').hasClass('n-small')) {
            transformCount = transformCount + transformXIntervalNext
            dotsContainer.find('ul.slick-dots li.dot-index-' + nextSlideAccurated).removeClass('n-small');
            const nextSlidePlusOne = nextSlideAccurated + 1
            dotsContainer.find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('n-small')
            dotsContainer.find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)')
            const pPointer = nextSlideAccurated - 3
            // const pPointerMinusOne = pPointer - 1
            console.log(pPointer, 'p-small')
            dotsContainer.find('ul.slick-dots li').removeClass('p-small')
            dotsContainer.find('ul.slick-dots li').eq(pPointer).addClass('p-small')
          } else {
            console.log('last')
          }
        }
      }
      else {
        if (dotsContainer.find('ul.slick-dots li.dot-index-' + nextSlideAccurated).hasClass('p-small')) {
          console.log(nextSlideAccurated, 'minus')
          if (!dotsContainer.find('ul.slick-dots li:first-child').hasClass('p-small')) {
            transformCount = transformCount + transformXIntervalPrev
            dotsContainer.find('ul.slick-dots li.dot-index-' + nextSlideAccurated).removeClass('p-small');
            const nextSlidePlusOne = nextSlideAccurated - 1
            dotsContainer.find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('p-small')
            dotsContainer.find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)')
            // const nPointer = currentSlideAccurated + 3
            const nPointerMinusOne = nextSlidePlusOne + 4
            console.log(nextSlidePlusOne, 'n-small')
            dotsContainer.find('ul.slick-dots li').removeClass('n-small')
            dotsContainer.find('ul.slick-dots li').eq(nPointerMinusOne).addClass('n-small')
          } else {
            console.log('first')
          }
        }
      }
    }
  })

  /*
  * Slick Slider Limit dots end
  */



  $('.slider-all-hotels-container', slider).slick({
    rows: 0,
    arrows: false,
    dots: true,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 15,
    variableWidth: true,
    centerMode: true,
    swipeToSlide: true,
    speed: 300,
    centerPadding: '10px',
    accessibility: true,
    lazyLoad: 'ondemand',
    appendDots: dotsContainer,
    customPaging : function(slider, i) {
      return '<button><svg role="button" tabindex="0" version="1.0" xmlns="http://www.w3.org/2000/svg"\n' +
          ' width="16.000000pt" height="16.000000pt" viewBox="0 0 16.000000 16.000000"\n' +
          ' preserveAspectRatio="xMidYMid meet">\n' +
          '\n' +
          '<g transform="translate(0.000000,16.000000) scale(0.100000,-0.100000)"\n' +
          'stroke="none">\n' +
          '<path d="M25 135 c-40 -39 -32 -96 16 -120 40 -21 66 -19 94 10 50 49 15 135\n' +
          '-55 135 -19 0 -40 -9 -55 -25z m95 -15 c28 -28 26 -66 -6 -86 -55 -37 -117 25\n' +
          '-80 80 20 32 58 34 86 6z"/>\n' +
          '<path class="dot" d="M57 103 c-14 -13 -7 -43 12 -53 28 -14 55 13 41 41 -10 19 -40 26\n' +
          '-53 12z"/>\n' +
          '</g>\n' +
          '</svg></button>'
    },
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          variableWidth: false,
          centerMode: false,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          variableWidth: false,
          centerMode: false,
          swipeToSlide: false,
        },
      },
    ],
  }).on('breakpoint', function () {
    hideDots($(this).find('.slick-slide'), $(this).find('.slick-dots'))
  })
  hideDots($('.slick-slide', slider), $('.slick-dots', slider))
}
